import { createContext } from 'react';
import type { TExtendedSize } from '../../tokens/types';

export interface HBAvatarGroupContextValue {
    size?: TExtendedSize;
}

export const HBAvatarGroupContext = createContext<
    HBAvatarGroupContextValue | undefined
>(undefined);
